import React, {useState, useEffect, useCallback} from 'react';
import {setShowLFOs} from 'actions/index.js';

const WAIT_TIME = 50;

const EDGE = 135;
window.testA = -15;
window.testB = -5;

export const useParameterFinder = (parameter, scrollContainer, scale, destinationPosition) => {
    let [pts, setPts] = useState(undefined);
    let [effectsView, setEffectsView] = useState(undefined);
    let [sourceEffectsView, setSourceEffectsView] = useState(undefined);
    let [parametersListView, setParametersListView] = useState(undefined);
    let [source, setSource] = useState(undefined);
    let [dest, setDest] = useState(undefined);

    let calculatePts = useCallback((e, scrollYView=parametersListView) => {
        if (!parameter) {
            return;
        }
        let track = parameter.context && parameter.context.track;
        if (track && track.isEffectsShowing && !track.isEffectsShowing()) {
            track.showEffects(true);
        }

        let mapperEffect = parameter.isMapped;
        if (mapperEffect && mapperEffect.track && mapperEffect.track.isEffectsShowing && !mapperEffect.track.isEffectsShowing()) {
            mapperEffect.track.showEffects(true);
        }

        if (parameter.context.lfoTrack) {
            // then show the lfos
            parameter.context.lfoTrack.sequencerEngine.dispatch(
                setShowLFOs(true));
        }

        // first find the element via parameter id
        if (dest && source) {
            // make sure track effects are showing
            let rect1 = dest.getBoundingClientRect();
            let height1 = dest.offsetHeight; //rect1.height;
            let width1 = rect1.width;
            let x1 = rect1.left;
            let y1 = rect1.top - height1;
            
            let rect2 = source.getBoundingClientRect();
            let height2 = source.offsetHeight;
            let width2 = rect2.width;
            let x2 = rect2.left;
            let y2 = rect2.top - height2;

            if (scrollContainer) {
                let scrollRect = scrollContainer.current.getBoundingClientRect();

                /*
                y2 += scrollContainer.current.scrollTop;
                y1 += scrollContainer.current.scrollTop;
                x2 += scrollContainer.current.scrollLeft;
                x1 += scrollContainer.current.scrollLeft;
                */


                /*
                x1 -= scrollRect.left;
                x2 -= scrollRect.left;
                y1 -= scrollRect.top;
                y2 -= scrollRect.top;
                */

            }

            /*
            x1 *= scale;
            y1 *= scale;
            x2 *= scale;
            y2 *= scale;
            */

            let hasPlane = false;
            if (scrollYView && scrollYView.className.includes("plane")) {
                // THIS IS FOR WHEN THE DESTINATION PARAMETEER IS ITSELF
                hasPlane = true;
                // IN A SCROLLABLE VIEW
                y2 -= 25;
                /*
                y2 += scrollYView.scrollTop;
                */
                let scrollRect = scrollYView.getBoundingClientRect();
                let scrollYTop = scrollRect.top;
                if (scrollYTop > rect2.top) {
                    y2 += (scrollYTop - rect2.top);
                } else if (scrollYTop + scrollRect.height < rect2.top) {
                    y2 -= (rect2.top - (scrollYTop + scrollRect.height)) -5;
                }
            }
            
            y1 += height1;
            if (!hasPlane) {
                y2 += height2;
            }
 
            if (y2 <= y1) {
                y2 += height2;
            } else  {
                y1 += height1;
            }

            let effectsRect = effectsView && effectsView.getBoundingClientRect();
            let effectXBound = 10000;
            if (effectsRect) {
                effectXBound = EDGE + effectsRect.width;
            }

            let _x2 = Math.max(EDGE, x2);
            if (_x2 > effectXBound) {
                _x2 = effectXBound;
                width2 = 1;
            }
            if (x1 > effectXBound) {
                x1 = effectXBound;
                width1 = 1;
            }
            if (_x2 + width2 > effectXBound) {
                width2 = effectXBound - _x2;
            }
            let pts = {
                x1: Math.max(EDGE, x1),
                y1,
                x2: _x2,
                y2,
                width1 : x1 < EDGE ? 10 : width1,
                width2 : x2 < EDGE ? 0 : width2,
                height1,
                height2
            };
            setPts(pts);
        } else {
                setPts(undefined);
            }
    }, [parameter, setPts, setEffectsView, source, dest, parametersListView, scale]);

    // ON MOUNT CALCULATE
    useEffect(() => {
        if (!parameter) {
            setPts(undefined);
            setDest(undefined);
            setSource(undefined);
            setEffectsView(undefined);
            if (effectsView) {
                effectsView.removeEventListener('scroll', calculatePts);
            }
            return;
        }
        setTimeout(() => {
            let dest = document.getElementById("parameter-" + parameter.id);
            findEffectsView(dest, setEffectsView);
            let source = document.getElementById("accumulator-map-source");
            findEffectsView(source, setSourceEffectsView);
            let listView = findParametersListView(source, setParametersListView);
            setDest(dest);
            setSource(source);
            calculatePts(undefined, listView);
        }, WAIT_TIME);
    }, [parameter, setPts, setDest, setSource, setEffectsView, setParametersListView, dest, source, scale]);

    // DEST SCROLL
    useEffect(() => {
        if (effectsView) {
            effectsView.addEventListener("scroll", calculatePts);
        }
        return () => effectsView ? effectsView.removeEventListener('scroll', calculatePts) : [];
    }, [setPts, parameter, effectsView, source, dest]);

    // PARAM LIST SCROLL
    useEffect(() => {
        if (parametersListView) {
            parametersListView.addEventListener("scroll", calculatePts);
        }
        return () => parametersListView ? parametersListView.removeEventListener('scroll', calculatePts) : [];
    }, [setPts, parameter, parametersListView, source, dest]);

    useEffect(() => {
        calculatePts();
    }, [destinationPosition, parameter, setPts, source, dest]);

    // SOURCE SCROLL
    useEffect(() => {
        if (sourceEffectsView && sourceEffectsView !== effectsView) {
            sourceEffectsView.addEventListener("scroll", calculatePts);
        }
        return () => sourceEffectsView && sourceEffectsView !== effectsView ? sourceEffectsView.removeEventListener('scroll', calculatePts) : [];
    }, [setPts, parameter, sourceEffectsView, effectsView, parametersListView, source, dest, scale]);


    const findView = useCallback((el, className, notClass, setter) => {
        // find the efffects view for this and listen
        let i =0;
        while (el && i < 30) {
            if (el.className === undefined) {
                return;
            }
            if (el.className.includes(className) && (!notClass || !el.className.includes(notClass))) {
                break;
            }
            el = el.parentNode;
            i++;
        }
        if (!el || !el.className.includes(className)) {
            return;
        }
        setter(el);
        return el;
    }, [setSourceEffectsView, setEffectsView]);

    const findParametersListView = useCallback((el, setter) => {
        return findView(el, "parameters-list", undefined, setter);
    }, [setSourceEffectsView]);

    const findEffectsView = useCallback((el, setter) => {
        return findView(el, "effects-view", "instrument-rack", setter);
    }, [setSourceEffectsView, setEffectsView]);


    return pts;
};
